import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { NebulaPlugin } from './nebula-plugin';
import { ShowPickerViewInfo } from '../../_interface/upalbum-int';
import ExecutionResult from '../../uplus-api/container/execution-result';
export var NebulaAlbumPlugin = function (_NebulaPlugin) {
    _inherits(NebulaAlbumPlugin, _NebulaPlugin);

    function NebulaAlbumPlugin() {
        _classCallCheck(this, NebulaAlbumPlugin);

        return _possibleConstructorReturn(this, (NebulaAlbumPlugin.__proto__ || Object.getPrototypeOf(NebulaAlbumPlugin)).apply(this, arguments));
    }

    _createClass(NebulaAlbumPlugin, [{
        key: 'showPickerView',
        value: function showPickerView(callback) {
            window.AlipayJSBridge.call('showPickerView', null, function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                    var info = new ShowPickerViewInfo();
                    info.path = ret === null || ret === void 0 ? void 0 : ret.retData.path;
                    info.base64 = ret === null || ret === void 0 ? void 0 : ret.retData.data;
                    callback(new ExecutionResult('000000', info));
                } else {
                    callback(new ExecutionResult(ret === null || ret === void 0 ? void 0 : ret.retCode));
                }
            });
        }
    }]);

    return NebulaAlbumPlugin;
}(NebulaPlugin);